export interface LabelValue {
  label: string;
  value: string;
}

export enum InputTypes {
  Text = 'text',
  PredictiveSelect = 'predictivedropdown',
  Select = 'dropdown',
}

export interface CustomField {
  type: InputTypes.Text | InputTypes.Select | InputTypes.PredictiveSelect;
  name: string;
  label: string;
  typeahead: boolean;
  options: LabelValue[];
  defaultvalue: DefaultValue;
  isRequired: boolean;
}

export interface DefaultValue {
  value: string;
  isVisible: boolean;
}
